import {RouteLoader} from '@dofleini/security';
import React, {memo, Suspense} from 'react';

import PageLoader from '@/components/PageLoader';

import routes from './routes';

const MainCMSRouter = () => {
  return (
    <Suspense fallback={<PageLoader/>}>
      <RouteLoader routes={routes} notfoundRedirect={'/'}/>
    </Suspense>
  );
};

export default memo(MainCMSRouter);
